import { render, staticRenderFns } from "./ViewBR.vue?vue&type=template&id=3bd72dc4&"
import script from "./ViewBR.vue?vue&type=script&lang=js&"
export * from "./ViewBR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports